import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  AcademicCapIcon,
  ReceiptRefundIcon,
  CashIcon,
  ClockIcon,
  BadgeCheckIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function GuideNFT() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);
  const [isOpenNft3, setIsOpenNft3] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
      <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
          <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
            UNA INTRO A LOS NFTs
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
          ¿NFT qué?
          </h3>
          
            <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>
         
          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft0(!isOpenNft0)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">¿Qué es un NFT?</h2>
                <svg
                  className={`${
                    isOpenNft0
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              
              <Transition
                show={isOpenNft0}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      <strong>NFT</strong> son las siglas de Non-Fungible-Token
                      (Token no fungible).
                    </p>
                    <p>
                      Las palabras <strong>Non-Fungible</strong> significan
                      único en su clase, insustituible, ¡como lo eres tú!
                    </p>
                    <p>
                      <strong>Token</strong> es una palabra elegante para decir
                      qué es un artículo.
                    </p>
                    <p>
                      Así que cuando lo juntamos tenemos:{" "}
                      <strong>un artículo único e irremplazable.</strong>
                    </p>
                    <p>
                      Ahora que la aburrida terminología está fuera del camino,
                      hablemos de lo que realmente son los NFTs.
                    </p>
                    <p>
                      Los NFTs se comercializan normalmente en forma de imagen
                      artística digital, pero también pueden incluir música,
                      palabras escritas y, básicamente, cualquier cosa que pueda
                      adoptar una medio digital.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Por qué necesito un NFT?
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
               
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Quizá pienses que <strong>NECESITAR</strong> es una
                      palabra muy fuerte. Te explicamos por qué al menos{" "}
                      <strong>QUIERES</strong> un NFT.
                    </p>
                    <p>
                      Los NFTs se están convirtiendo rápidamente en una forma de
                      encontrar la representación perfecta de quién eres. Hay
                      NFTs abstractos para los días en los que te sientes
                      "indiferente" y para los días en los que no te sientes
                      así, hay NFTs de todo tipo de "animales espirituales" así
                      como impresiones artísticas de prácticamente cualquier
                      tipo de "estilo" que te dicte tu estado de ánimo.
                    </p>
                    <p>
                      Con cada NFT que posees, obtienes acceso (membresía) a lo
                      que se conoce como una comunidad (en su mayoría otros
                      propietarios de membresías) donde las personas con ideas
                      afines llegan a comunicarse a nivel global sobre intereses
                      comunes. Estos intereses comunes suelen ser el resultado
                      de que estas personas se sientan atraídas por lo que el
                      proyecto NFT pretende conseguir.
                    </p>
                    <p>
                      <strong>Esto se llama hoja de ruta (Roadmap).</strong>
                    </p>
                    <p>
                      Esta hoja de ruta contiene una serie de compromisos
                      adquiridos por el proyecto con su comunidad y actúa como
                      un resumen de lo que el proyecto pretende hacer en
                      diferentes puntos de su recorrido. Puede incluir
                      beneficios tanto virtuales (normalmente llamados Web3)
                      como del mundo real (lo que normalmente llamamos Web2).
                      Pueden ser descuentos, accesos a bonificaciones, artículos
                      premiados físicamente o, simplemente, ventajas económicas.
                      Estos beneficios suelen denominarse la{" "}
                      <strong>"Utilidad"</strong> de un proyecto, es decir, qué
                      usos aporta su posesión.
                    </p>
                    <p>
                      Esta suele ser una de las partes más interesantes de un
                      proyecto NFT, y puede ayudar realmente a responder si
                      resuena contigo y, si lo hace, también puede responder por
                      qué <strong>NECESITAS</strong> ser uno de sus miembros.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Qué tienen de bueno los NFTs?
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Quizá te preguntes por qué todo el mundo habla de los
                      NFTs.
                    </p>
                    <p>
                      <strong>
                        Los NFTs son una alternativa moderna e innovadora a las
                        formas de arte más tradicionales, se publican y
                        comercian en línea a través del blockchain.
                      </strong>{" "}
                      Por lo tanto, el arte NFT es más accesible que el arte
                      tradicional. Basta con navegar por el mercado elegido (por
                      ejemplo, OpenSea o Nifty Gateway) y hacer una compra en
                      línea en lugar de tener que visitar una serie de galerías
                      de arte en persona para encontrar la pieza que deseas.
                    </p>
                    <p>
                      Además, las oportunidades para los aspirantes a artistas
                      son más amplias aquí, ya que cualquiera puede publicar sus
                      propias obras de arte para venderlas en línea a una gran
                      audiencia. Además, a diferencia del mercado de arte
                      tradicional, los artistas reciben ingresos recurrentes en
                      concepto de derechos de autor cada vez que se vende su
                      obra, un aspecto que los artistas nunca habían visto antes
                      de los NFT.
                    </p>
                    <p>
                      La mayoría de los proyectos de NFT también tienen sus
                      correspondientes plataformas de medios sociales (por
                      ejemplo, Twitter o Discord) que dan a conocer el proyecto
                      y sus visiones dentro de la Web3. A partir de esto, se
                      construyen comunidades de personas que comparten estos
                      mismos puntos de vista y aspiraciones. Por ejemplo, muchos
                      proyectos pretenden sensibilizar y dar apoyo a
                      organizaciones benéficas a través de sus proyectos de NFT
                      y de los beneficios obtenidos.
                    </p>
                    <p>
                      <strong>
                        Concluyendo, los NFTs son un método innovador e
                        inclusivo de compra y venta de obras de arte que también
                        puede proporcionar apoyo a la comunidad en general.
                      </strong>
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpen(!isOpen)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Son los NFT una buena inversión?
                </h2>
                <svg
                  className={`${
                    isOpen
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpen}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                 <div className="px-6 mt-4 pt-6 py-y border-t">
                <div class="relative mt-2 bg-white overflow-hidden text-left">
                  <div class="ml-4">
                    <div>
                      <p>
                        Esta pregunta no es tan clara como un "Sí" o un "No", y
                        he aquí la razón.
                      </p>
                      <br />
                      <p>
                        La propia definición de la palabra inversión es un
                        activo o artículo adquirido con el objetivo de generar
                        ingresos o apreciación. La apreciación se refiere al
                        aumento del valor de un activo a lo largo del tiempo.
                      </p>
                      <br />
                      <p>
                        Hay múltiples factores que afectan al potencial de
                        inversión de un NFT. El valor también puede reducirse al
                        beneficio que proporcionan a cada persona.
                      </p>
                      <br />
                      <p>
                        Factores como la utilidad, el estilo artístico, la
                        comunidad que hay detrás del NFT, los beneficios de la
                        hoja de ruta, las asociaciones de marca, etc., juegan un
                        papel para definir el valor, tanto desde el punto de
                        vista financiero como desde el de la realización
                        personal. A veces, invertir en algo que te hace feliz es
                        tan beneficioso como una ganancia financiera.
                      </p>
                      <br />
                      <p>
                        Desde un punto de vista puramente financiero, como
                        cualquier activo, los NFTs están sujetos a las fuerzas
                        del mercado.
                      </p>
                    </div>

                    <div class="mt-6">
                      <p>Éstas pueden ser:</p>
                      <br />
                      <ul className="list-disc list-outside">
                        <li>
                          Subidas/bajadas de los NFTs generalmente causados por
                          grandes factores macroeconómicos (que pueden ser del
                          mundo real o específicos de las criptomonedas).
                        </li>

                        <li>
                          La publicación de información sobre un determinado NFT
                          o sus competidores, incluyendo:
                          <br />
                          <ul className="ml-10">
                            <li>- Asociaciones (generalmente buenas),</li>
                            <li>- Costes inesperados (malos),</li>
                            <li>
                              - Gasto en elementos de la hoja de ruta (bueno),
                            </li>
                            <li>- Reseñas favorables (buenas),</li>
                            <li>
                              - Compras por parte de un reputado inversor de NFT
                              (bueno).
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <br />
                      <p>
                        De hecho, al igual que los mercados financieros
                        tradicionales, todas las fuentes de información pueden
                        afectar al valor de los NFTs y, cuando la información
                        está disponible libremente, los mercados la toman y la
                        traducen en cambios en la oferta o la demanda de un NFT
                        concreto en el mercado abierto.
                      </p>
                      <br />
                      <p>
                        El consejo más común que se escucha en este espacio es
                        que es importante hacer su propia investigación (DYOR
                        “Do Your Own Research”).
                      </p>
                      <br />
                      <p>Y es muy cierto.</p>
                      <br />
                      <p>
                        Informarse sobre los distintos proyectos y sus planes de
                        futuro desempeña un papel importante a la hora de
                        especular sobre qué proyectos pueden tener éxito frente
                        a los que pueden carecer de ciertos elementos que
                        "atraigan a los inversores". Los que hacen el trabajo
                        duro de investigar los proyectos son los que más a
                        menudo toman decisiones de inversión acertadas.
                      </p>
                      <br />
                      <p>
                        Así pues, aunque la pregunta sobre si los NFTs son una
                        buena inversión no es fácil de responder, sí pone de
                        manifiesto que hay muchos factores que contribuyen a la
                        elección final.
                      </p>
                      <br />
                      <p>
                        Hay un conjunto de factores que queda claro por encima
                        de todo: el espacio de los NFTs es aún relativamente
                        joven. Con el tiempo, habrá más participantes y una
                        mayor demanda de NFT en general. Es un espacio que verá
                        la innovación y el uso en el mundo real. Cuanto mejor
                        preparado estés, más posibilidades tendrás de tomar una
                        decisión bien razonada sobre los proyectos en los que te
                        interese invertir.
                      </p>
                      <br />
                    </div>
                  </div>
                </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft3(!isOpenNft3)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Qué obtengo al poseer un NFT?
                </h2>
                <svg
                  className={`${
                    isOpenNft3
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              
              <Transition
                show={isOpenNft3}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                <div class="relative bg-white overflow-hidden text-left">
                  <div class="ml-4">
                    <div>
                      <p class="">
                        Al comprar un NFT en uno de los muchos mercados que
                        existen, estás pagando por un token que representa un
                        elemento único en la cadena de bloques. Puede que te
                        preguntes por qué la gente paga millones de dólares por
                        algo que puedes "guardar con el botón derecho del
                        ratón", pero esencialmente posees una pieza de arte
                        digital que es exclusiva para ti.
                      </p>
                      <br />
                      <p class=" mt-4">
                        Seguro que has oído hablar de la Mona Lisa, el original
                        está valorado en 800 millones de dólares porque es el
                        único en el mundo pintado por Leonardo da Vinci. Claro
                        que puedes comprar una réplica en Amazon por 10 dólares,
                        pero no es lo mismo que poseer el original.
                      </p>
                      <br />
                      <p class=" mt-4">
                        Mientras que muchos proyectos de NFT son únicamente para
                        el arte, otros vienen con derechos y utilidades
                        adicionales. Sin embargo, esto depende de los proyectos
                        que elijas, por lo que es importante hacer tu propia
                        investigación (DYOR) antes de invertir para ver qué
                        utilidades extra trae.
                      </p>
                      <br />
                    </div>
                    <div class="mt-6">
                      <p>
                        <strong>
                          Por ejemplo, Bored Ape Yacht Club (BAYC) es uno de los
                          proyectos NFT más populares y de los que más se habla.
                          También es, en el momento de escribir este artículo,
                          el NFT más costoso que se comercializa. Cuando posees
                          un BAYC obtienes una membresía del "Yacht Club" que te
                          da acceso a:
                        </strong>
                      </p>
                      <br />
                      <ul className="list-disc" role="list">
                        <li>
                          <strong>Eventos de la comunidad:</strong> esto incluye
                          el acceso a regalos y juegos "sólo para titulares"
                          dentro de Discord, donde puedes ganar NFTs y otros
                          artículos interesantes.
                        </li>
                        <br />
                        <li>
                          <strong>El baño (The Bathroom): </strong>se trata de
                          otra ventaja para los miembros, ya que los titulares
                          pueden pintar un píxel cada quince minutos en una
                          cartera de baño virtual. El baño no ofrece nada más
                          que un tablero de dibujo comunitario. Sin embargo, al
                          igual que los otros beneficios del club, ayuda a
                          mantener a los coleccionistas interesados en el
                          proyecto y su universo.
                        </li>
                        <br />
                        <li>
                          <strong>Derechos comerciales: </strong>esto significa
                          que el titular puede utilizar el BAYC que posee en
                          cualquier mercancía. Por ejemplo, puede poner su Mono
                          en una camiseta y venderla.
                        </li>
                        <br />
                        <li>
                          <strong>El Club: </strong>es un club para los
                          titulares de BAYC que incluye muchas celebridades de
                          alto perfil con las que puedes interactuar y hablar.
                        </li>
                        <br />
                        <li>
                          <strong>Airdrops: </strong>el proyecto enviará NFTs a
                          los propietarios de BAYC al azar como agradecimiento
                          por invertir y creer en el equipo.
                        </li>
                        <br />
                        <li>
                          <strong>Minteo gratuito (Free Mint): </strong>los
                          titulares de BAYC tienen la oportunidad de mintear un
                          proyecto de forma gratuita.
                        </li>
                        <br />
                      </ul>
                      <p>
                        Muchos de los ejemplos anteriores también se incluyen en
                        los beneficios de utilidad de muchos proyectos en el
                        mercado, y es crucial evaluar el valor de "lo que
                        obtienes" como parte del coste de entrada a un proyecto.
                      </p>
                      <br />
                    </div>
                  </div>
                </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
